export default __webpack_public_path__ + "static/media/grid4.9a79e65b.jpg";